import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --silvy-gap: calc(10rem / var(--default-rem-px-count));
      --silvy-intro-gap: calc(32rem / var(--default-rem-px-count));
    }

    .silvy-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .intro {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: var(--silvy-intro-gap);
      padding-bottom: calc(40rem / var(--default-rem-px-count));
      width: 100%;
      color: var(--block-text-color, #222);
    }

    .intro::part(body) {
      display: flex;
      flex-direction: column;
      gap: var(--silvy-intro-gap);
    }

    /* The intro row is baseline-aligned from 600px, but cta-text sets
       align-self on its own :host; only a rule from out here lets it join
       the baseline group. */
    .learn-more {
      flex: 0 0 auto;
      align-self: baseline;
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 3;
      display: grid;
      grid-template-columns: repeat(
        var(--silvy-per-row-mobile, 3),
        minmax(0, 1fr)
      );
      gap: var(--silvy-gap);
    }

    .image {
      width: 100%;
      aspect-ratio: 1 / 1;
      overflow: hidden;
      display: block;
    }

    .image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    /* Auto-populated from /samples: swatches keep their own aspect ratio
       instead of being cropped square. Rows align to the top so mixed
       heights don't stretch. */
    .images--native {
      align-items: start;
    }

    .images--native .image {
      aspect-ratio: auto;
    }

    .images--native .image img {
      height: auto;
      object-fit: contain;
    }

    @media (min-width: 600px) {
      .intro {
        grid-column: 2 / 14;
        padding-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .intro::part(body) {
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        gap: var(--silvy-intro-gap);
      }

      .intro::part(description) {
        flex: 1 1 0;
        min-width: 0;
        max-width: calc(551rem / var(--default-rem-px-count));
      }

      .images {
        grid-column: 2 / 14;
        grid-template-columns: repeat(
          var(--silvy-per-row-tablet, 6),
          minmax(0, 1fr)
        );
      }
    }

    @media (min-width: 1024px) {
      .intro {
        flex-direction: row;
        align-items: baseline;
      }

      .intro::part(header) {
        flex: 1 1 0;
        min-width: 0;
        max-width: calc(318rem / var(--default-rem-px-count));
      }

      .intro::part(body) {
        flex: 1 1 0;
        min-width: 0;
      }

      .images {
        grid-template-columns: repeat(
          var(--silvy-per-row-desktop, 9),
          minmax(0, 1fr)
        );
      }
    }
  `,
];
